import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadApplicationConfig } from './actions/index'

const Initializer = () => {
    var dispatch = useDispatch();
    useEffect(() => {
        const pathToExclude = ["/viewvideo", "/viewupdates"];
        if (pathToExclude.some(x => window.location.pathname.startsWith(x))) {
            return;
        }
        loadApplicationConfig()(dispatch);
    }, [])
    return (<></>)
}

export default Initializer;